import { z } from 'zod/v4';

import { vehicleTypeSchema } from '../../../schemas/vehicle-type.schema';
import { vehicleDimensionSchema } from './vehicle-dimension.schema';

export const vehicleDimensionsThresholdSchema = z.object({
  vehicleDimensionMax: vehicleDimensionSchema,
  vehicleDimensionMin: vehicleDimensionSchema,
  vehicleType: vehicleTypeSchema,
});

export type VehicleDimensionsThreshold = z.infer<
  typeof vehicleDimensionsThresholdSchema
>;
